import { inject, Injectable } from '@angular/core';
import { FirestoreService } from './firestore.service';
import { TenantContextService } from './tenant-context.service';
import { UserUnsubscribe } from '@models';

@Injectable({
  providedIn: 'root',
})
export class UnsubscribesService {
  private readonly firestoreService = inject(FirestoreService);
  private readonly tenantContext = inject(TenantContextService);

  create(data: Omit<UserUnsubscribe, 'id'>) {
    return this.firestoreService.create(
      this.tenantContext.collections.UNSUBSCRIBES,
      data,
    );
  }
}
